/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import { IBaseSection, IServiceType } from '../services/CoverageDiscoveryResponseStateManager/contracts'
import { CommonUtils } from './CommonUtils'

export class ServiceTypeHelper {
	static getMedicareSTC(val: IBaseSection): IServiceType[] {
		if (!val.summary.serviceTypes) {
			return []
		}
		const types: IServiceType[] = []
		const serviceTypes = val.summary.serviceTypes
			.filter(r => r.code === '30')
			.slice(0, 1)
			.shift()
		if (serviceTypes) {
			types.push(serviceTypes)
		}
		const allOtherSTC = val.summary.serviceTypes.filter(r => r.code !== '30').sort((a, b) => CommonUtils.compareProperty(a.definition, b.definition))
		allOtherSTC.forEach(stc => {
			types.push(stc)
		})
		return types
	}
	static getCommercialSTC(val: IBaseSection): IServiceType[] {
		if (!val.summary.serviceTypes) {
			return []
		}
		const types: IServiceType[] = []
		const stc30 = val.summary.serviceTypes
			.filter(r => r.serviceCode === '30')
			.slice(0, 1)
			.shift()
		if (stc30 !== undefined) types.push(stc30)
		const allOtherSTC = val.summary.serviceTypes.filter(r => r.serviceCode !== '30').sort((a, b) => CommonUtils.compareProperty(a.serviceCodeDescription, b.serviceCodeDescription))
		allOtherSTC.forEach(stc => {
			types.push(stc)
		})
		return types
	}
}
